<template>
  <div>
    <v-container fluid>
      <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
        <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>

      <v-card class="box">
        <v-toolbar flat dense class="toolbar">
          <v-toolbar-title>Coordinator Approve</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-row justify="center" dense>
          <v-col cols="12" sm="2">
            <p><v-icon color="error">*</v-icon><b>Academic Year</b></p>
            <v-autocomplete
              color="#0F2027"
              dense
              rounded
              required
              v-model="ay"
              :items="ay_list"
              item-text="ay"
              item-value="id"
              label="Academic Year"
              outlined
              persistent-hint
              hint="Please Select Academic Year"
              @change="getInstallmentData()"
            />
          </v-col>
          <!-- <v-col cols="12" sm="2">
                    <p><b>Standard</b></p>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="standard"  :items="standard_list" item-text="standard" item-value="id" label="Standard" outlined persistent-hint hint="Please Select Standard"/>
                </v-col> -->
          <v-col cols="12" sm="2">
            <p><b>Approval Status</b></p>
            <v-autocomplete
              color="#0F2027"
              dense
              rounded
              required
              v-model="transport_status"
              :items="transport_status_list"
              item-text="status"
              item-value="id"
              label="Transport Approval Status"
              outlined
              persistent-hint
              hint="Please Select Status"
            />
          </v-col>
          <v-col cols="12" sm="2" v-if="transport_installment_list!=''">
            <p><b>Installment</b></p>
            <v-autocomplete
              color="#0F2027"
              dense
              rounded
              required
              v-model="transport_installment"
              :items="transport_installment_list"
              item-text="name"
              item-value="id"
              label="Transport Installment"
              outlined
              persistent-hint
              hint="Please Select Installment"
            />
          </v-col>
          <v-col cols="12" sm="3" v-if="all_learner_list!=''">
            <p><b>Learner</b></p>
            <v-autocomplete
              color="#0F2027"
              dense
              rounded
              required
              v-model="learner"
              :items="all_learner_list"
              item-text="learner"
              item-value="id"
              label="Student"
              outlined
              persistent-hint
              hint="Please Select Student"
            />
          </v-col>
        </v-row>
        <!-- //v-if="this.transport_installment && this.transport_status && this.learner"> -->
        <v-row justify="center" dense>
          <v-col cols="12" sm="2" md="2"></v-col>
          <v-col col="12" sm="4" md="4">
            <v-btn color="warning" @click="fetch()">Fetch</v-btn>
          </v-col>
        </v-row>
      </v-card>

      <v-card
        class="box"
        v-if="learner_transport_fees_installment_details!=''"
      >
        <v-data-table
          :headers="headers"
          :items="learner_transport_fees_installment_details"
          :search="search"
        >
          <template v-slot:top>
            <v-toolbar flat class="toolbar">
              <v-toolbar-title>List</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </v-toolbar>
          </template>
          <template v-slot:[`item.action`]="{ item }">
            <div v-if="item.can_approve == true && item.is_blocked_for_transport==false">
              <v-avatar size="35">
                <v-icon
                  class="mr-4 v-icon-size"
                  color="green"
                  @click="editItem(item)"
                  >mdi-application-export</v-icon
                >
              </v-avatar>
            </div>
            <div v-else>
              <b
                >Transporter Did Not Approved Yet / Application Is
                Rejected/Student Is Blocked For Transport...</b
              >
            </div>
          </template>
          <template v-slot:[`item.history`]="{ item }">
            <div>
              <v-avatar size="35">
                <v-icon
                  class="mr-4 v-icon-size"
                  color="red"
                  @click="getArrovalHistory(item)"
                  >mdi-eye</v-icon
                >
              </v-avatar>
            </div>
          </template>
        </v-data-table>
      </v-card>

      <v-dialog v-model="show_approve_transport_card" fullscreen>
        <v-card>
          <v-toolbar class="toolbar no-display" flat dense>
            <v-btn icon dark @click="show_approve_transport_card = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>
              <strong> Details </strong>
            </v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card class="box">
            <v-row justify="center" dense>
              <v-col cols="12" sm="2">
                <p><b>PRN</b></p>
                <v-text-field
                  outlined
                  dense
                  type="text"
                  v-model="child_details.registration_number"
                  readonly
                  filled
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <p><b>Student Name</b></p>
                <v-text-field
                  outlined
                  dense
                  type="text"
                  v-model="child_details.learner"
                  readonly
                  filled
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="2">
                <p><b>Standard</b></p>
                <v-text-field
                  outlined
                  dense
                  type="text"
                  v-model="child_details.standard"
                  readonly
                  filled
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="2">
                <p><b>Pick Up Time</b></p>
                <v-text-field
                  outlined
                  dense
                  type="text"
                  v-model="child_details.pickup_time"
                  readonly
                  filled
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="2">
                <p><b>Drop Time</b></p>
                <v-text-field
                  outlined
                  dense
                  type="text"
                  v-model="child_details.drop_time"
                  readonly
                  filled
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card>
          <v-card class="box">
            <v-row justify="center" dense>
              <v-col cols="12" sm="2" md="2">
                <p><b>Route Stop</b></p>
                <v-text-field
                  outlined
                  dense
                  type="text"
                  v-model="child_details.routestop_name"
                  readonly
                  filled
                ></v-text-field>
                <!-- <v-autocomplete
                  color="#0F2027"
                  dense
                  rounded
                  required
                  v-model="routestop"
                  :items="route_stops"
                  item-text="name"
                  item-value="id"
                  label="Route Stop"
                  outlined
                  persistent-hint
                  hint="Please Select Route Stop"
                  readonly
                /> -->
              </v-col>
              <v-col cols="12" sm="2" md="2">
                <p><b>Route</b></p>
                <v-text-field
                  outlined
                  dense
                  type="text"
                  v-model="child_details.route_name"
                  readonly
                  filled
                ></v-text-field>
                <!-- <v-autocomplete
                  color="#0F2027"
                  dense
                  rounded
                  required
                  v-model="route"
                  :items="routes"
                  item-text="name"
                  item-value="id"
                  label="Route"
                  outlined
                  persistent-hint
                  readonly
                /> -->
              </v-col>
              <v-col cols="12" sm="3" md="2">
                <p><b>Distance Slab in KM</b></p>
                <v-text-field
                  outlined
                  dense
                  type="text"
                  v-model="child_details.distanceslab"
                  readonly
                  filled
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="2" md="2">
                <p><b>Total Fees In Rs.</b></p>
                <v-text-field
                  outlined
                  dense
                  type="text"
                  v-model="child_details.applicable_fees"
                  readonly
                  filled
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="2" md="2">
                <p><b>Installment Name</b></p>
                <v-text-field
                  outlined
                  dense
                  type="text"
                  v-model="child_details.transport_installment"
                  readonly
                  filled
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row justify="center" dense>
              <v-col cols="12" sm="6" md="3" v-if="isLastAuthority">
                <p><b>Change Installment and amount</b></p>
                <v-autocomplete
                  color="#0F2027"
                  dense
                  rounded
                  required
                  v-model="transportinstallment"
                  :items="transport_installment_list"
                  item-value="id"
                  item-text="name"
                  @change="setValue(transportinstallment)"
                  label="Installment"
                  outlined
                  persistent-hint
                />
              </v-col>
              <v-col cols="12" sm="6" md="2" v-if="totalfees_approved != ''">
                <p><b>Total Fees Applicable In Rs.</b></p>
                <v-text-field
                  outlined
                  dense
                  type="text"
                  v-model="totalfees_approved"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="2">
                <p><b>Action</b></p>
                <v-autocomplete
                  color="#0F2027"
                  dense
                  rounded
                  required
                  v-model="transportstatus"
                  :items="transport_status_list"
                  item-text="status"
                  item-value="id"
                  label="Status"
                  outlined
                  persistent-hint
                />
              </v-col>
              <v-col cols="12" sm="6" md="2">
                <p><b>Remark</b></p>
                <v-text-field
                  outlined
                  dense
                  type="text"
                  v-model="approve_remark"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row justify="center" dense >
              <v-btn color="warning" @click="saveApproveStatus()">Save</v-btn>
            </v-row>
            <!-- <v-row justify="center" dense v-if="is_final_approved">
              <p><b>Application Is Already Approved...</b></p> 
            </v-row> -->
          </v-card>
        </v-card>
      </v-dialog>
      <v-dialog v-model="show_approve_history_card" fullscreen>
        <v-card>
          <v-toolbar class="toolbar no-display" flat dense>
            <v-btn icon dark @click="show_approve_history_card = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>
              <strong> Transport Approval History </strong>
            </v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card class="box">
            <v-row justify="center" dense>
              <v-col cols="12" sm="2">
                <p><b>PRN</b></p>
                <v-text-field
                  outlined
                  dense
                  type="text"
                  v-model="transportApplicationsDetails.registration_number"
                  readonly
                  filled
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <p><b>Student Name</b></p>
                <v-text-field
                  outlined
                  dense
                  type="text"
                  v-model="transportApplicationsDetails.learner"
                  readonly
                  filled
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="2">
                <p><b>Standard</b></p>
                <v-text-field
                  outlined
                  dense
                  type="text"
                  v-model="transportApplicationsDetails.standard"
                  readonly
                  filled
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="2">
                <p><b>Pick Up Time</b></p>
                <v-text-field
                  outlined
                  dense
                  type="text"
                  v-model="transportApplicationsDetails.pickup_time"
                  readonly
                  filled
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="2">
                <p><b>Drop Time</b></p>
                <v-text-field
                  outlined
                  dense
                  type="text"
                  v-model="transportApplicationsDetails.drop_time"
                  readonly
                  filled
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row justify="center" dense>
              <v-col cols="12" sm="4" md="2">
                <p><b>Route Stop</b></p>
                <v-text-field
                  outlined
                  dense
                  type="text"
                  v-model="transportApplicationsDetails.routestop"
                  readonly
                  filled
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4" md="2">
                <p><b>Route</b></p>
                <v-text-field
                  outlined
                  dense
                  type="text"
                  v-model="transportApplicationsDetails.route"
                  readonly
                  filled
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4" md="2">
                <p><b>Distance Slab in KM</b></p>
                <v-text-field
                  outlined
                  dense
                  type="text"
                  v-model="transportApplicationsDetails.distanceslab"
                  readonly
                  filled
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4" md="2">
                <p><b>Total Fees Applicable In Rs.</b></p>
                <v-text-field
                  outlined
                  dense
                  type="text"
                  v-model="transportApplicationsDetails.totalfees"
                  readonly
                  filled
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4" md="1">
                <p><b>Installment</b></p>
                <v-text-field
                  outlined
                  dense
                  type="text"
                  v-model="transportApplicationsDetails.transport_installment"
                  readonly
                  filled
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4" md="3">
                <p><b>Installment Fees Applicable In Rs</b></p>
                <v-text-field
                  outlined
                  dense
                  type="text"
                  v-model="
                    transportApplicationsDetails.transport_installment_amount
                  "
                  readonly
                  filled
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card>

          <v-card class="box" v-if="transportApprovalDetails.length > 0">
            <v-data-table
              :headers="headers_history"
              :items="transportApprovalDetails"
            >
              <template v-slot:top>
                <v-toolbar flat class="toolbar">
                  <v-toolbar-title>Transport Approval History</v-toolbar-title>
                  <v-divider class="mx-4" inset vertical></v-divider>
                  <v-spacer></v-spacer>
                </v-toolbar>
              </template>
              <template v-slot:[`item.is_last_approval`]="{ item }">
                <span v-if="item.is_last_approval">
                  <v-icon class="mr-2 v-icon-size" color="success"
                    >mdi-check-circle-outline</v-icon
                  >
                </span>
                <span v-else>
                  <v-icon class="mr-2 v-icon-size" color="error"
                    >mdi-close-circle-outline</v-icon
                  >
                </span>
              </template>
              <template v-slot:[`item.edit_status`]="{ item }">
                <span v-if="item.can_edit">
                  <v-avatar size="35">
                    <v-icon
                      class="mr-4 v-icon-size"
                      color="green"
                      @click="changeApprovalStatus(item)"
                      >mdi-pencil</v-icon
                    >
                  </v-avatar>
                </span>
                <span v-else>--</span>
              </template>
            </v-data-table>
          </v-card>
        </v-card>
      </v-dialog>

      <v-dialog v-model="show_change_approve_status_card" max-width="800px">
        <v-card>
          <v-toolbar class="toolbar" flat dense>
            <v-toolbar-title>
              <strong> Change Approval Status</strong>
            </v-toolbar-title>
          </v-toolbar>
          <v-col cols="12" sm="12" md="12">
            <v-card class="box">
              <v-row justify="center" dense>
                <v-col cols="12" sm="6" md="6">
                  <p><b>Select Status*</b></p>
                  <v-autocomplete
                    color="#0F2027"
                    dense
                    rounded
                    required
                    v-model="change_transport_status"
                    :items="transport_status_list_without_all"
                    item-text="status"
                    item-value="id"
                    label="Status"
                    outlined
                    persistent-hint
                  />
                </v-col>
              </v-row>
              <v-row justify="center" dense>
                <v-btn
                  class="button"
                  @click="savechangeApprovalStatus()"
                  :loading="loader"
                  >save</v-btn
                >
                <v-btn
                  class="button"
                  @click="show_change_approve_status_card = false"
                  >Close</v-btn
                >
              </v-row>
            </v-card>
          </v-col>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
  <!-- /. root div -->
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
  data: () => ({
    isLastAuthority:false,
    search: "",
    loader: false,
    snackbar_msg: "",
    color: "",
    snackbar: false,
    overlay: false,
    ay_list: [],
    ay: "",
    standard_list: [],
    standard: "",
    transport_status_list: [],
    transport_status: "",
    transport_installment_list: [],
    transport_installment: "",
    all_learner_list: [],
    learner: "",
    learner_transport_fees_installment_details: [],
    show_approve_transport_card: false,
    show_change_approve_status_card: false,
    child_details: {
      lid: "",
      registration_number: "",
      learner: "",
      standard: "",
      pickup_time: "",
      drop_time: "",
      academicYear: "",
      contact: "",
      resedential_address: "",
      totalfees: "",
      applicable_fees: "",
      paid_till_now: "",
      routestop: "",
      route: "",
      distanceslab: "",
      transport_installment_amount: "",
      transport_installment: "",
      routestop_name: "",
      route_name: "",
    },
    totalfees_approved: "",
    route_stops: [],
    routestop: "",
    routes: [],
    route: "",
    transport_installment_list: [],
    transportinstallment: "",
    transport_status_list: [],
    transportstatus: "",
    approve_remark: "",
    learnertransportfeesinstallment: "",
    transportApprovalDetails: [],
    show_approve_history_card: false,
    transportApplicationsDetails: [],
    learner_transport_fees_installment_id: "",
    is_final_approved: false,
    transport_status_list_without_all: [],
    change_transport_status: "",
    learner_transport_fees_approval_id: "",
    headers: [
      { text: "SR No", value: "srno" },
      { text: "PRN", value: "prn" },
      { text: "Student", value: "name" },
      { text: "Installment", value: "transportinstallment" },
      { text: "Route Stop", value: "route_stop" },
      { text: "Amount To Pay", value: "amount" },
      { text: "Paid Till Now", value: "paid_till_now" },
      { text: "Final Approval Status", value: "transportapprovalstatus" },
      { text: "Action", value: "action" },
      { text: "My Approval Status", value: "history" },
    ],
    headers_history: [
      { text: "SR No", value: "count" },
      { text: "Authority", value: "transportapprovalhierarchy" },
      { text: "Authority Level", value: "authority_level" },
      { text: "Is Last Authority", value: "is_last_approval" },
      { text: "Application Date", value: "application_push_date" },
      { text: "Action Date", value: "application_action_date" },
      { text: "Status", value: "transportapprovalstatus" },
      { text: "Remark", value: "remark" },
      { text: "Edit", value: "edit_status" },
    ],
  }),
  methods: {
      getInstallmentData(){
      this.transport_installment_list=[],
      this.all_learner_list=[],
       this.learner_transport_fees_installment_details =[]
       const data = {
        academicYear: this.ay
      };
      this.overlay = true;
      axios
        .post("/ParentTransport/getInstallmentDataByAy", data)
        .then((res) => {
          if (res.data.flag == "YES") {
             this.transport_installment_list = res.data.transport_installment_list;
            this.all_learner_list = res.data.all_learner_list;
            if(this.transport_installment_list==''){
                this.showSnackbar("red", "Installment List Not Defined For This Academicyear...");    
                return
            }           
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    changeApprovalStatus(item) {
      this.show_change_approve_status_card = true;
      this.learner_transport_fees_approval_id = item.id;
    },
    savechangeApprovalStatus(item) {
      if (!confirm("Are You Sure You Want To Change...?")) return;
      const data = {
        approval_status: this.change_transport_status,
        learner_transport_fees_approval_id:
          this.learner_transport_fees_approval_id,
      };
      this.overlay = true;
      axios
        .post("/ParentTransport/changeApprovalStatus", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.transportApprovalDetails = res.data.transportApprovalDetails;
            this.show_change_approve_status_card = false;
            this.fetch();
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
             this.fetch();
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          // this.selected_date=""
        });
    },
    setValue(installment_name) {
      // //alert("installment_name::"+installment_name)
      // this.totalfees_approved = this.child_details.totalfees;
      // if (installment_name.name != "Yearly") {
      //   this.totalfees_approved = parseFloat(this.child_details.totalfees / 2);
      // } else {
      //   this.totalfees_approved;
      // }
      // return this.totalfees_approved;
      const data = {
        installment: installment_name,
        learner_transport_fees_installment_id:
          this.learner_transport_fees_installment_id,
      };
      this.overlay = true;
      axios
        .post("/ParentTransport/getInstallmentAmount", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.totalfees_approved = res.data.final_amount;
            //  this.show_fees = true
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          // this.selected_date=""
        });
    },
    getArrovalHistory(item) {
      const data = {
        learnertransportfeesinstallment: item.id,
      };
      this.overlay = true;
      axios
        .post("/ParentTransport/getArrovalHistory", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.transportApprovalDetails = res.data.transportApprovalDetails;
            this.transportApplicationsDetails =
              res.data.transportApplicationsDetails[0];
            this.show_approve_history_card = true;
            // this.showSnackbar("green", res.data.snackbar);
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    saveApproveStatus() {
      if (!confirm("Are You Sure You Want To Save...?")) return;
      if (this.transportstatus == null || this.transportstatus == "") {
        this.showSnackbar("red", "Please Select Status");
        return;
      }
      const data = {
        learnertransportfeesinstallment: this.learnertransportfeesinstallment,
        transportstatus: this.transportstatus,
        remark: this.approve_remark,
        transportinstallment: this.transportinstallment,
        total_fees: this.totalfees_approved,
      };
      this.overlay = true;
      axios
        .post("/ParentTransport/saveApproveStatusCoordinator", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            (this.show_approve_transport_card = false), this.fetch();
            this.showSnackbar("green", res.data.snackbar);
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    editItem(item) {
      this.learner_transport_fees_installment_id = item.id;
      const data = {
        learner_transport_fees_installment: item.id,
      };
      this.overlay = true;
      axios
        .post("/ParentTransport/fetchTransportApplicationsDetails", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            //this.showSnackbar("green", res.data.snackbar);
            this.child_details.registration_number =
              res.data.registration_number;
            this.child_details.learner = res.data.learner;
            this.child_details.lid = res.data.lid;
            this.child_details.standard = res.data.standard;
            this.child_details.pickup_time = res.data.pickup_time;
            this.child_details.drop_time = res.data.drop_time;
            this.child_details.academicYear = res.data.academicYear;
            this.child_details.contact = res.data.contact;
            this.child_details.applicable_fees = res.data.applicable_fees;
            this.child_details.resedential_address =
              res.data.resedential_address;
            this.route_stops = res.data.route_stops;
            this.routes = res.data.routes;
            this.child_details.totalfees = res.data.totalfees;
            this.child_details.paid_till_now = res.data.paid_till_now;
            this.child_details.routestop = res.data.routestop;
            this.child_details.route = res.data.route;
            (this.child_details.distanceslab = res.data.distanceslab),
              (this.routestop = res.data.routestop_id);

            this.child_details.routestop_name = res.data.routestop;
            this.child_details.route_name = res.data.route;
            this.child_details.transport_installment_amount =
              res.data.transport_installment_amount;
            this.child_details.transport_installment =
              res.data.transport_installment;
            this.is_final_approved = res.data.is_final_approved;

            this.route = res.data.route_id;
            this.transport_installment_list =
              res.data.transport_installment_list;
            this.transport_status_list = res.data.transport_status_list;
            //this.transportinstallment=res.data.transport_installment_id
            this.learnertransportfeesinstallment =
              res.data.learnertransportfeesinstallment;
            this.show_approve_transport_card = true;
            // this.learner_transport_fees_installment_details=res.data.learner_transport_fees_installment_details
          } else if (res.data.flag == "No") {
            this.showSnackbar("red", res.data.snackbar);
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    fetch() {
      if(this.transport_status==''){
          this.showSnackbar("red","Please Select Status");
            return
      }
       if(this.transport_installment==''){
          this.showSnackbar("red","Please Select Installment");
            return
      }
      if(this.learner==''){
          this.showSnackbar("red","Please Select Students");
          return
      }
      const data = {
        academicYear: this.ay,
        learner: this.learner,
        transport_status: this.transport_status,
        transport_installment: this.transport_installment,
        standard: this.standard,
      };
      this.overlay = true;
      axios
        .post("/ParentTransport/fetchTransportApplicationsLevel2", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            //this.showSnackbar("green", res.data.snackbar);
            this.learner_transport_fees_installment_details =
              res.data.learner_transport_fees_installment_details;
            this.transport_status_list_without_all =
              res.data.transport_status_list;
               this.isLastAuthority=res.data.isLastAuthority
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    onLoad() {
      axios
        .post("ParentTransport/approveTransportApplication")
        .then((res) => {
          if (res.data.flag == "YES") {
            (this.ay_list = res.data.ay_list), (this.ay = res.data.curreny_ay);
            this.standard_list = res.data.standard_list;
            this.transport_status_list = res.data.transport_status_list;
            this.transport_installment_list =
              res.data.transport_installment_list;
            this.all_learner_list = res.data.all_learner_list;
            this.overlay = false;
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong!!!");
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
  mounted() {
    this.onLoad();
  },
  watch: {},
};
</script>
<style scoped>
</style>